// extracted by mini-css-extract-plugin
var _1 = "styles-module__routingTip___Vfihf";
var _2 = "styles-module__routingTipText___AIwi6";
var _3 = "styles-module__routingTipTitle___EIiBe";
var _4 = "styles-module__textContent___TDlbg";
export { _1 as "routingTip", _2 as "routingTipText", _3 as "routingTipTitle", _4 as "textContent" }
